<template>
    <b-card no-body class="overflow-hidden">
        <b-row no-gutters>
            <b-col md="4">
                <div class="item-photo" :style="style"></div>
            </b-col>
            <b-col md="8">
                <b-card-body
                    title-tag="h6"
                    :title="
                        `${entry.vehicle.plate} - ${entry.vehicle.brand} - (${entry.vehicle_entry_type.name})`
                    "
                >
                    <b-card-text>
                        <table class="table table-sm" v-if="!goingOut">
                            <tbody>
                                <tr>
                                    <td><strong>Fecha Ingreso</strong></td>
                                    <td>{{ entry.created_at | datetime }}</td>
                                </tr>
                                <tr>
                                    <td><strong>Duración</strong></td>
                                    <td>{{ entry.created_at | duration }}</td>
                                </tr>
                                <tr>
                                    <td><strong>Destino</strong></td>
                                    <td>{{ entry.destination.name }}</td>
                                </tr>
                                <tr v-if="!!entry.visited_person">
                                    <td><strong>Persona Visitada</strong></td>
                                    <td>{{ entry.visited_person.name }}</td>
                                </tr>
                                <tr>
                                    <td><strong>Registrado por</strong></td>
                                    <td>{{ entry.user.name }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div v-else>
                            <app-form-select-input
                                v-if="showVehicleRouteField"
                                label="Ruta y/o destino o procedencia"
                                :options="vehicleRouteOptionsWithOther"
                                v-model="vehicleRoute"
                                :required="false"
                                @change="onVehicleRouteChange"
                            />
                            <div v-if="showVehicleRouteField && vehicleRoute === 'otro'" class="form-group">
                                <label for="vehicle-route-other">
                                    Especifique la ruta y/o destino o procedencia
                                    <span class="field-required-mark">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="vehicle-route-other"
                                    name="vehicle-route-other"
                                    class="form-control"
                                    v-model.trim="vehicleRouteOther"
                                    @input="$v.vehicleRouteOther.$touch()"
                                    placeholder="Ingrese la ruta"
                                />
                                <span v-if="$v.vehicleRouteOther.$error" class="field-error">
                                    Debe especificar la ruta del vehículo
                                </span>
                            </div>
                            <b-form-textarea
                                v-model="notes"
                                rows="4"
                                autofocus
                            ></b-form-textarea>
                        </div>
                        <table class="table table-sm">
                            <thead>
                                <tr>
                                    <th>Nombre</th>
                                    <th>Tipo</th>
                                    <th>Teléfono</th>
                                    <th>Sale</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="personEntry in entry.person_entries"
                                    :key="personEntry.id"
                                >
                                    <td
                                        :class="{
                                            overlined: !!personEntry.completed,
                                        }"
                                    >
                                        {{ personEntry.person.name }}
                                    </td>
                                    <td
                                        :class="{
                                            overlined: !!personEntry.completed,
                                        }"
                                    >
                                        {{ personEntry.visitor_type.name }}
                                    </td>
                                    <td
                                        :class="{
                                            overlined: !!personEntry.completed,
                                        }"
                                    >
                                        {{ personEntry.person.phone }}
                                    </td>
                                    <td>
                                        <input
                                            type="checkbox"
                                            v-model="passengers"
                                            :value="personEntry.id"
                                            :disabled="!!personEntry.completed"
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </b-card-text>
                    <b-row>
                        <b-col>
                            <app-form-textarea-input
                                v-if="!goingOut"
                                :readonly="true"
                                label="Notas"
                                id="notas"
                                v-model="previousNotes"
                            ></app-form-textarea-input>
                        </b-col>
                    </b-row>
                    <div class="d-flex justify-content-end">
                        <b-btn
                            variant="primary"
                            v-if="!goingOut"
                            @click="goingOut = true"
                            >Dar Salida</b-btn
                        >
                        <div v-else>
                            <b-btn variant="secondary" @click="goingOut = false"
                                >Cancelar</b-btn
                            >
                            <b-btn variant="confirm" @click="register"
                                >Confirmar</b-btn
                            >
                        </div>
                    </div>
                </b-card-body>
            </b-col>
        </b-row>
    </b-card>
</template>
<script>
import FormSelectInput from '../../../../UI/Controls/Forms/FormSelectInput.vue'
import configurationRepository from '../../../../../repositories/configuration.repository'
import { required } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import repo from '../../../../../repositories/repo'

export default {
    components: {
        appFormSelectInput: FormSelectInput
    },
    props: {
        entry: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            goingOut: false,
            notes: '',
            passengers: [],
            previousNotes: '',
            vehicleRoute: '',
            vehicleRouteOther: '',
            vehicleRouteOptions: []
        }
    },
    validations() {
        let vehicleRouteOther = {}
        
        if (this.showVehicleRouteField) {
            vehicleRouteOther = {
                required: (value) => {
                    if (this.vehicleRoute === 'otro') {
                        return required(value)
                    }
                    return true
                }
            }
        }
        
        return { vehicleRouteOther }
    },
    computed: {
        ...mapGetters(['client', 'user']),
        style() {
            return {
                backgroundImage: `url(${
                    !!this.entry.vehicle.vehicle_photos &&
                    this.entry.vehicle.vehicle_photos.length > 0
                        ? this.entry.vehicle.vehicle_photos[0].photo_url
                        : 'images/generic_vehicle.png'
                })`,
                backgroundPosition: 'center',
                backgroundSize: !!this.entry.vehicle.photo
                    ? 'cover'
                    : 'contain',
                backgroundRepeat: 'no-repeat',
            }
        },
        showVehicleRouteField() {
            return this.vehicleRouteOptions && this.vehicleRouteOptions.length > 0
        },
        vehicleRouteOptionsWithOther() {
            const otherOption = { id: 'otro', name: 'Otro' }
            return [...this.vehicleRouteOptions, otherOption]
        },
    },
    methods: {
        async register() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                toastr.error('Debe diligenciar correctamente todos los campos obligatorios')
                return false
            }

            // Concatenar la ruta del vehículo en las notas antes de enviar
            const notesWithRoute = this.buildNotesWithVehicleRoute()
            
            const { data } = await repo.post(`vehicle-departures`, {
                notes: notesWithRoute,
                userId: this.user.id,
                entryId: this.entry.id,
                passengers: this.passengers,
            })
            const passengersCount = this.passengers.length
            toastr.success('La salida fue registrada satisfactoriamente')
            this.notes = ''
            this.vehicleRoute = ''
            this.vehicleRouteOther = ''
            this.goingOut = false
            this.passengers = []
            this.$emit('departured', { withPassengers: !!passengersCount })
        },
        onVehicleRouteChange(value) {
            this.vehicleRoute = value
            if (value !== 'otro') {
                this.vehicleRouteOther = ''
                this.$v.vehicleRouteOther.$reset()
            }
        },
        buildNotesWithVehicleRoute() {
            let notes = this.notes || ''
            let routeText = ''
            
            if (this.vehicleRoute === 'otro' && this.vehicleRouteOther) {
                routeText = this.vehicleRouteOther
            } else if (this.vehicleRoute && this.vehicleRoute !== 'otro') {
                const selectedRoute = this.vehicleRouteOptionsWithOther.find(route => route.id === this.vehicleRoute)
                routeText = selectedRoute ? selectedRoute.name : ''
            }
            
            if (routeText) {
                const routePrefix = 'Ruta y/o destino o procedencia: ' + routeText
                if (notes.trim()) {
                    return routePrefix + '\n' + notes
                } else {
                    return routePrefix
                }
            }
            
            return notes
        },
        async loadVehicleRouteOptions() {
            let clientId = null
            
            if (this.entry.structure) {
                clientId = this.entry.structure.client_id || this.entry.structure.client?.id
            } else if (this.entry.destination && this.entry.destination.structure) {
                clientId = this.entry.destination.structure.client_id || this.entry.destination.structure.client?.id
            } else if (this.client && this.client.id) {
                clientId = this.client.id
            }
            
            if (!clientId) {
                return
            }
            
            try {
                const { data } = await configurationRepository.getVehicleRouteOptions(clientId)
                this.vehicleRouteOptions = data.options || []
            } catch (error) {
                console.error('Error al cargar las opciones de ruta de vehículo:', error)
                this.vehicleRouteOptions = []
            }
        },
        handleControlAccessNotes() {
            const noteTypes = { entry: 'Ingreso', departure: 'Salida' }
            this.previousNotes = this.entry.vehicle.accessControlComments
                .map(
                    (item) =>
                        `- [${item.created_at}] ${item.notes} (${
                            noteTypes[item.type]
                        })`
                )
                .join('\n')
        },
    },
    created(){
        this.handleControlAccessNotes()
        this.loadVehicleRouteOptions()
    }
}
</script>
<style scoped>
.item-photo {
    height: 175px;
    display: flex;
    align-items: center;
}
</style>
